import styled from 'styled-components';

// Import components
import { Button } from 'components/elements';

export const StyledButton = styled(Button)`
	margin: 0 1rem;
`;
